import type { AdminUserRecord } from "../../lib/admin";

const formatter = new Intl.NumberFormat("en-US");

export function AdminWalletFeeTotal({ user }: { user: AdminUserRecord }) {
  const incomplete = user.unrecordedFeeJobs > 0;
  return (
    <span className="stats-wallet-fees" title={incomplete
      ? `${user.unrecordedFeeJobs} historical job(s) need fee verification. Network fees are excluded.`
      : "STC service fees for recorded inscription jobs, including pending confirmations. Bitcoin network fees are excluded."}>
      <small>{incomplete ? "RECORDED STC FEES" : "STC FEES PAID"}</small>
      <strong>{user.unrecordedFeeJobs === user.jobs ? "NOT RECORDED" : `${formatter.format(user.serviceFeeSats)} sats`}</strong>
      {incomplete ? <small>{formatter.format(user.unrecordedFeeJobs)} {user.unrecordedFeeJobs === 1 ? "JOB" : "JOBS"} UNVERIFIED</small> : null}
    </span>
  );
}
